import React from 'react';

// Styles & Assets
import styles from './PatientPreconfigHeader.module.css';
import helpers from '../../../styles/Helpers.module.css';
import unlinkSVG from '../../../assets/icons/unlink.svg';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';
import { getFullName } from '../../../services/getPatientAtribute';

// Hooks
import { useTranslation } from 'react-i18next';
import { useToast } from '../../../hooks/useToast';
import usePatientStore from '../../../stores/patient-store';
import useHttp from '../../../hooks/useHttp';

// Interfaces
import { Patient } from '../../../interfaces/Patient';
import { Preconfiguration } from '../../../interfaces/Preconfigurations';

interface Props {
    patient: Patient
    preconfig: Pick<Preconfiguration, 'id' | 'name'>
    setShow: React.Dispatch<React.SetStateAction<boolean>>
}

const PatientPreconfigHeader: React.FC<Props> = ({ patient, preconfig, setShow }) => {
    const { t } = useTranslation();
    const toast = useToast();
    const { sendRequest } = useHttp();

    const updatePatient = usePatientStore(state => state.updatePatient);

    const caseID = patient?.patient_preconfigs?.[0]?.case_id;

    const handleUnassign = () => {
        if (caseID == null) {
            toast.error(t('patients_not_unassigned_correctly'));
            return;
        }

        sendRequest({
            url: getEnvironmentApiUrl() + 'preconfig/' + preconfig.id + '/unassign_cases',
            method: 'PUT',
            body: [caseID]
        }, () => {
            updatePatient({ patient_preconfigs: [] });
            setShow(false);
        }, () => {
            toast.error(t('patients_not_unassigned_correctly'));
        });
    };

    return (
        <div className={styles.topContainer}>
            <div>
                <h1 className='dialogTitle'>
                    {t('preconfiguration')}: {preconfig.name ?? ''}
                </h1>
                <h2 className='dialogSubTitle'>
                    {patient.mrn} - {getFullName(patient)}
                </h2>
            </div>
            <button className={helpers.unassignButton} onClick={handleUnassign}>
                {t('unassign')}
                <img alt='unlink' src={unlinkSVG} className={styles.unlink} />
            </button>
        </div>
    );
};

export default PatientPreconfigHeader;